import { CVState } from "@/store/types/CV.state";
import { Module } from "vuex";
import { RootState } from "@/store/types/root.state";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: CVState = {
    toolkit: [],
    jobs: [],
    studies: [],
    languages: [],
    loading: false,
    displayingSection: 'About',
    honors: [],
};

const namespaced = true;

export const CVModule: Module<CVState, RootState> = {
    namespaced,
    actions,
    getters,
    mutations,
    state,
}